/* eslint-disable eqeqeq */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { AppBar, IconButton, makeStyles, Toolbar, Typography } from '@material-ui/core';
// import useCommonStyles from 'styles';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const useStyles = makeStyles((theme) => ({
  root: {},
  notificationHeight: {
    // height: "50px",
    backgroundColor: "#FFFFFF",
  },
  appBarNotification: {
    // color: "#FFFFFF",
    backgroundColor: "#F6CF51",
    cursor: 'pointer'
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  notificationTxt: {
    // wordBreak: "break-all",
    wordBreak: "break-word",
  },
}));

function HeaderNotification(props = {}) {
  const { showNotification, updateUserLocalSettings, hideCloseButton, onClickHandler = () => null } = props;
  const classes = useStyles(props);

  const setShowNotification = () => {
    updateUserLocalSettings({
     body: {
      hideNotification: 1
     }
    })
  }
  if (!showNotification) {
    return null
  }
  return (
    <AppBar
        color="secondary"
        position="sticky"
        className={classes.appBarNotification}
        onClick={onClickHandler}
      >
        <Toolbar className={classes.toolbar}>
          <Typography className={classes.notificationTxt} variant="body1" color="inherit">
            {/* <strong>SmartSpend is temporarily unavailable.</strong> This maintenance period may take a few weeks and we will notify you promptly upon its return to service. Thank you for your patience. */}
            <strong>Action Required:</strong> Because of financial regulations, we need to complete your identity verification. Click here to continue
          </Typography>
          {hideCloseButton ? null :<IconButton onClick={setShowNotification} edge="end" color="inherit">
            <CloseOutlinedIcon />
          </IconButton>}
        </Toolbar>
      </AppBar>
  );
  // const commonClasses = useCommonStyles(props);
}

HeaderNotification.defaultProps = {
  test: " HeaderNotification component ",
};

HeaderNotification.propTypes = {
  test: PropTypes.string,
};

export default memo(HeaderNotification);
